<template>
  <UiHTMLRenderer :class="props.class" :content="disclaimer" :components="rendererComponents" />
</template>

<script setup lang="ts">
import { type RouteLocation } from "#vue-router"

import {
  type Disclaimer,
  getSourceFromMap,
} from "@finq/app-base/components/layout/Footer/Disclaimer/disclaimer-shared"

const props = defineProps<{
  class?: ClassValue
  routeName?: RouteLocation["name"]
  routeParams?: TypedRouteProps["params"]
  locale?: string
}>()

const { locale } = useI18n({ useScope: "local" })

const disclaimerByRouteMap: Disclaimer.SourceMap = {
  "/": "default",
}

const disclaimer = computed(() => {
  const sourceVal = getSourceFromMap(disclaimerByRouteMap)

  const translationsLocale = translations[locale.value as "en"]
  return isKey(translationsLocale, sourceVal) ? translationsLocale[sourceVal] : translationsLocale.default
})

const translations = {
  en: {
    default: `Investment advice is offered through FINQ AI LLC, a SEC-registered investment advisor. Such registration does not imply a certain level of skill or training and no inference to the contrary should be made. FINQ AI is wholly owned by FINQ Digital, Ltd., an Israeli limited company. Additional information about FINQ AI is available on the SEC's website at <a target='_blank' href='https://adviserinfo.sec.gov/'>https://adviserinfo.sec.gov/</a>. Please note that FINQ AI and its personnel do not give legal or tax advice. You are advised to seek the advice of a qualified professional prior to making any decision based on any specific information contained herein. The specific tax consequences of any investment or strategy will depend on your specific tax situation.
      <br/><br/>
      FINQ's ETFs are powered by AI-driven, systematic strategies based on continuous asset analysis and proprietary rankings. These ETFs are designed to offer structured, rules-based investment exposure. However, all investments involve risk, and there is no guarantee that any strategy will achieve its objectives or outperform the market. Any references to past or hypothetical performance are for illustrative purposes only, do not reflect actual returns, and are not guarantees of future performance. FINQ AI's model strategies reflect back-tested data and are not personalized. Only qualified users may view performance-related content. By proceeding, users confirm they meet the intended audience criteria.`,
  },
}

const rendererComponents = {}
</script>
